/** Country helpers for the filter's multiselect (TZ §5.2). Pure. */

export type CountryOption = { code: string; name: string };

/** Regional-indicator flag for an ISO-3166 alpha-2 code. */
export function flagOf(iso: string): string {
  const s = iso.toUpperCase();
  if (s.length !== 2) return "";
  return String.fromCodePoint(...[...s].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
}


/** ISO-prefix matches sort first (TZ §5.2), then name substring matches. */
export function rankCountries(options: CountryOption[], query: string): CountryOption[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return options;
  const iso = options.filter((c) => c.code.toLowerCase().startsWith(needle));
  const rest = options.filter(
    (c) => !c.code.toLowerCase().startsWith(needle) && c.name.toLowerCase().includes(needle),
  );
  return [...iso, ...rest];
}

